import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    PLANT_SPECIES_QUERY,
    SINGLE_PLANT_SPECIES_QUERY,
    CREATE_PLANT_SPECIES_MUTATION,
    UPDATE_PLANT_SPECIES_MUTATION,
    DELETE_PLANT_SPECIES_MUTATION
} from "@/graphql/plantSpecies.js";

const state = {
    plantSpecies: []
};
const getters = {};
const mutations = {
    [types.SET_PLANT_SPECIES](state, plantSpecies) {
        state.plantSpecies = plantSpecies;
    },
    [types.SORT_PLANT_SPECIES](state) {
        state.plantSpecies.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_PLANT_SPECIES](state, plantSpecies) {
        var index = state.plantSpecies.findIndex(function(element) {
            return element.node.id == plantSpecies.id;
        });

        const node = { node: plantSpecies };

        if (index > -1) {
            state.plantSpecies.splice(index, 1, node);
        } else {
            state.plantSpecies.unshift(node);
        }
    },
    [types.DELETE_PLANT_SPECIES](state, plantSpecies) {
        var index = state.plantSpecies.find(function(element, index) {
            if (element.id == plantSpecies.id) {
                return index;
            }
        });

        if (index > -1) {
            state.plantSpecies.splice(index, 1);
        }
    }
};
const actions = {
    async fetchPlantSpecies(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: PLANT_SPECIES_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);

                    const plantSpecies = response.data.tenantPlantSpecies.edges;

                    // update store
                    context.commit(types.SET_PLANT_SPECIES, plantSpecies);

                    // sort
                    context.commit(types.SORT_PLANT_SPECIES);

                    resolve(plantSpecies);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglPlantSpecies(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_PLANT_SPECIES_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantSpecies = JSON.parse(JSON.stringify(response.data.plantSpecies));

                    // update store
                    context.commit(types.UPSERT_PLANT_SPECIES, plantSpecies);

                    // sort
                    context.commit(types.SORT_PLANT_SPECIES);

                    resolve(plantSpecies);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createPlantSpecies(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_PLANT_SPECIES_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantSpecies =
                        response.data.createPlantSpecies.plantSpecies;

                    // update store
                    context.commit(types.UPSERT_PLANT_SPECIES, plantSpecies);

                    // sort
                    context.commit(types.SORT_PLANT_SPECIES);

                    resolve(plantSpecies);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePlantSpecies(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_PLANT_SPECIES_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantSpecies =
                        response.data.updatePlantSpecies.plantSpecies;

                    // update store
                    context.commit(types.UPSERT_PLANT_SPECIES, plantSpecies);

                    // sort
                    context.commit(types.SORT_PLANT_SPECIES);

                    resolve(plantSpecies);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deletePlantSpecies(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_PLANT_SPECIES_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const plantSpecies =
                        response.data.deletePlantSpecies.plantSpecies;

                    // update store
                    context.commit(types.DELETE_PLANT_SPECIES, plantSpecies);

                    resolve(plantSpecies);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
